module.exports = __webpack_public_path__ + "img/randys-seafood-gumbo.29426d22.jpg";